require('../global');
require('../scripts/jQuery/select2.min.js');

import VueSlider from 'vue-slider-component';
import app from './index';

Vue.component('vue-slider', VueSlider);

window.$store = app.$store;

require('./bindVariables');

app.$mount('#app');
